import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  PRIMARY: null,
  SECONDARY: null
});